"use client";

import BaseActionModal from "@/components/shared/dialogs/base-action-modal/base-action-modal";
import LocationDropdownSwitchModalContent from "@/components/shared/location-dropdown/location-dropdown-state-check/dialogs/location-dropdown-switch-modal-content";
import { IndividualStateConfig, StateConfig } from "@/lib/states-config";

export interface PreferencesStateMismatchModalProps {
  currentState: StateConfig;
  preferenceState: IndividualStateConfig;
  onClose: () => void;
}

export function PreferencesStateMismatchModal({
  currentState,
  preferenceState,
  onClose,
}: PreferencesStateMismatchModalProps) {
  return (
    <BaseActionModal.Root onClose={onClose}>
      <LocationDropdownSwitchModalContent
        variant="preferences"
        currentState={currentState}
        preferenceState={preferenceState}
        onSecondaryClick={onClose}
      />
    </BaseActionModal.Root>
  );
}
